export function polygonPoints(region, width, height) {
  return region.polygon.map(([x, y]) => `${x * width},${y * height}`).join(' ');
}

export function regionStyle(region) {
  const [left, top, right, bottom] = region.bbox;
  return {
    left: `${left * 100}%`,
    top: `${top * 100}%`,
    width: `${Math.max(0.02, right - left) * 100}%`,
    height: `${Math.max(0.025, bottom - top) * 100}%`
  };
}
